export enum SecurityQuestionGroupEnum {
  Mechanical = 'MECHANICAL',
  Driver = 'DRIVER',
  Inspection = 'INSPECTION',
  DangerousGoods = 'DANGEROUS_GOODS',
}

export enum SecurityCheckTypeEnum {
  Arrival = 'ARRIVAL',
  Departure = 'DEPARTURE',
}

export enum SecurityCheckContextType {
  Hub = 'HUB',
  Compartment = 'COMPARTMENT',
}
